<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button type="text">
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.managerName"
              placeholder="请输入资产管理人员名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.name"
              placeholder="请输入资产名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.borrower"
              placeholder="请输入借用人名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          is-select-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          :multiple-selection.sync="multipleSelection"
          @reloadData="loadTableData(tableList)"
          @returnBack="returnBackFun"
          @revokeBorrow="revokeBorrowFun"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { listFixedAssetBorrowByPageApi, returnFixedAssetBorrowApi, revokeFixedAssetBorrowApi } from '@/api/fixedAsset'

export default {
  name: 'FixedAssetNotReturnList',
  components: { CustomTable },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: '借用未还固定资产清单'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'fixed_asset_not_return_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'returnBack',
            label: '借用归还',
            method: 'returnBack'
          },
          {
            prop: 'revokeBorrow',
            label: '撤销借用',
            method: 'revokeBorrow'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            managerName: '',
            name: '',
            borrower: '',
            notReturn: 'true'
          }
        }
      },
      isPaging: true,
      multipleSelection: [],
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this
        _this.multipleSelection = []
        _this.tableList.initTableColumn = [
          { prop: 'managerName', label: '管理人员', filterColumn: 'tfa.manager_name', width: 110 },
          { prop: 'name', label: '资产名称', filterColumn: 'tfa.name', width: 240 },
          { prop: 'unit', label: '计量单位', filterColumn: 'tfa.unit', width: 110 },
          { prop: 'borrower', label: '借用人', filterColumn: 'tfab.borrower', width: 110 },
          { prop: 'borrowNumber', label: '借用数量', filterColumn: 'tfab.borrow_number', width: 105 },
          { prop: 'borrowDateValue', label: '借用日期', filterColumn: 'tfab.borrow_date', width: 110 },
          { prop: 'statusValue', label: '状态', filterColumn: 'tfab.status', filterData: 'status', width: 90 },
          { prop: 'borrowRemark', label: '借用情况说明', filterColumn: 'tfab.borrow_remark' }
        ]
        _this.tableList.tableColumns = _this.tableList.initTableColumn
        _this.tableList.tableQuery.search.sourceType = _this.sourceType
        _this.searchData(_this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this
      _this.tableList.tableLoading = true
      _this.tableList.tableQuery.sort.order = ''
      listFixedAssetBorrowByPageApi({ condition: JSON.stringify(_this.tableList.tableQuery) }).then(response => {
        _this.tableList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        _this.handleData(_this.tableList, data)
        _this.tableList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 归还借用资产
    returnBackFun () {
      let _this = this
      if (_this.multipleSelection.length === 0) {
        _this.$message({ message: '请选择要归还的借用固定资产', type: 'warning' })
        return false
      }
      let returnBackArray = []
      _this.multipleSelection.forEach(item => {
        returnBackArray.push({ id: item.id })
      })
      _this.$confirm('是否确定归还选择的固定资产借用？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        returnFixedAssetBorrowApi({ returnBackData: JSON.stringify(returnBackArray) }).then(response => {
          _this.$message({ message: response.message, type: 'success' })
          _this.reloadMasterData()
        })
      }).catch(() => { })
    },
    // 撤销借用
    revokeBorrowFun () {
      let _this = this
      if (_this.multipleSelection.length === 0) {
        _this.$message({ message: '请选择要撤销的资产借用记录', type: 'warning' })
        return false
      }
      let revokeArray = []
      _this.multipleSelection.forEach(item => {
        revokeArray.push({ id: item.id })
      })
      _this.$confirm('是否确定撤销选择的固定资产借用？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        revokeFixedAssetBorrowApi({ revokeData: JSON.stringify(revokeArray) }).then(response => {
          _this.$message({ message: response.message, type: 'success' })
          _this.reloadMasterData()
        })
      }).catch(() => { })
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      this.$emit('reloadData')
      this.loadTableData(this.tableList)
    },
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
